// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("rescript/lib/js/curry.js");
var JsxRuntime = require("react/jsx-runtime");
var Image$ReactHooksTemplate = require("../../common/image.res.js");

function SurveyBuilderToolbar(props) {
  var onGetBulkTriggerToken = props.onGetBulkTriggerToken;
  var onPreview = props.onPreview;
  var onSettingsClick = props.onSettingsClick;
  var onTabChange = props.onTabChange;
  var activeTab = props.activeTab;
  var tabClass = function (isActive) {
    return "sb-toolbar-tab " + (
            isActive ? "sb-toolbar-tab--active" : ""
          );
  };
  return JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsxs("div", {
                      children: [
                        JsxRuntime.jsx("a", {
                              children: JsxRuntime.jsx("img", {
                                    className: "h-16-px mr-2",
                                    src: Image$ReactHooksTemplate.backArrow
                                  }),
                              className: "flex items-center",
                              href: "/projects/all?selectedProjectId=" + String(props.projectId)
                            }),
                        JsxRuntime.jsx("div", {
                              className: "sb-toolbar-brand-divider"
                            }),
                        JsxRuntime.jsxs("div", {
                              children: [
                                JsxRuntime.jsx("div", {
                                      children: "Survey Builder",
                                      className: "sb-toolbar-brand-label"
                                    }),
                                JsxRuntime.jsx("div", {
                                      children: props.surveyName,
                                      className: "sb-toolbar-brand-title"
                                    })
                              ],
                              className: "sb-toolbar-brand-text"
                            })
                      ],
                      className: "sb-toolbar-brand"
                    }),
                JsxRuntime.jsxs("div", {
                      children: [
                        JsxRuntime.jsx("button", {
                              children: "Questions",
                              className: tabClass(activeTab === "Questions"),
                              type: "button",
                              onClick: (function (param) {
                                  Curry._1(onTabChange, "Questions");
                                })
                            }),
                        JsxRuntime.jsx("button", {
                              children: "Logic",
                              className: tabClass(activeTab === "Logic"),
                              type: "button",
                              onClick: (function (param) {
                                  Curry._1(onTabChange, "Logic");
                                })
                            }),
                        JsxRuntime.jsx("button", {
                              children: "Translations",
                              className: tabClass(activeTab === "Translations"),
                              type: "button",
                              onClick: (function (param) {
                                  Curry._1(onTabChange, "Translations");
                                })
                            }),
                        JsxRuntime.jsx("button", {
                              children: "Settings",
                              className: "sb-toolbar-tab",
                              type: "button",
                              onClick: (function (param) {
                                  Curry._1(onSettingsClick, undefined);
                                })
                            })
                      ],
                      className: "sb-toolbar-tabs"
                    }),
                JsxRuntime.jsxs("div", {
                      children: [
                        onGetBulkTriggerToken !== undefined ? JsxRuntime.jsxs("button", {
                                children: [
                                  JsxRuntime.jsx("img", {
                                        className: "h-14-px sb-btn-icon",
                                        src: Image$ReactHooksTemplate.share
                                      }),
                                  "Get Bulk Trigger Token"
                                ],
                                className: "sb-btn sb-btn--token",
                                type: "button",
                                onClick: (function (param) {
                                    Curry._1(onGetBulkTriggerToken, undefined);
                                  })
                              }) : null,
                        JsxRuntime.jsxs("button", {
                              children: [
                                JsxRuntime.jsx("img", {
                                      className: "h-14-px sb-btn-icon",
                                      src: Image$ReactHooksTemplate.preview
                                    }),
                                "Preview"
                              ],
                              className: "sb-btn sb-btn--preview",
                              type: "button",
                              onClick: (function (param) {
                                  Curry._1(onPreview, undefined);
                                })
                            }),
                        JsxRuntime.jsxs("button", {
                              children: [
                                JsxRuntime.jsx("img", {
                                      className: "h-14-px",
                                      src: Image$ReactHooksTemplate.save
                                    }),
                                "Save"
                              ],
                              className: "sb-btn sb-btn--save",
                              type: "button",
                              onClick: props.onSave
                            })
                      ],
                      className: "sb-toolbar-actions"
                    })
              ],
              className: "sb-toolbar"
            });
}

var make = SurveyBuilderToolbar;

exports.make = make;
/* react/jsx-runtime Not a pure module */
